import { useMutation } from '@apollo/client/react';
import { loggerService } from '@brainpool/logger';
import { CaseDetails } from '../types/Case';
import { CREATE_CASE } from '../queries/CreateCase';
import { LIST_CASES } from '../queries/ListCases';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

export function useCreateCase() {
  const context: LoggerContextProps = {
    action: 'createCase',
  };
  const [createCaseMutation, { data, loading, error }] = useMutation<{
    createCase: CaseDetails;
  }>(CREATE_CASE, {
    refetchQueries: [{ query: LIST_CASES }],
  });

  const createCase = async (input: { name: string }) => {
    try {
      const { data } = await createCaseMutation({
        variables: { input },
      });
      if (data && data.createCase && data.createCase.id) {
        loggerService.log({
          message: `Case created successfully: ${data.createCase.id}`,
          logLevel: 'success',
          context,
          userMessage: {
            title: 'SUCCESS',
            message: `Your project was successfully created.`,
          },
        });
      }
    } catch (error) {
      handleError(error, context, 'Failed to create case.');
    }
  };

  return { createCase, data, loading, error };
}
